import { createContext } from "react";

export interface UserContextValue {
  user: any;
  setUser: (_user: any) => void;
  colors: string[];
  setColors: (_colors: string[]) => void;
  isLoadingUser: boolean;
  setIsLoadingUser: (_isLoading: boolean) => void;
}

export const UserContext = createContext<UserContextValue | undefined>(
  undefined,
);
